import type { PageProps, SolutionsPageProps } from "@/types";
import React, { FC } from "react";
import { SolutionsHero } from "../solutions";
import { SolutionsItem } from "../solutions/item";

export const Solutions: FC<PageProps<SolutionsPageProps>> = (props) => {
  return (
    <div>
      <SolutionsHero
        label={props.meta.translation.solutions.hero.label}
        title={props.data.title}
        description={props.data.description}
      />
      <SolutionsItem
        cols={props.data.automationContent}
        cover={props.data.automationCover}
        nextPage={props.data.automationNextPage}
      />
      <SolutionsItem
        cols={props.data.paymentOrchestrationContent}
        cover={props.data.paymentOrchestrationCover}
        nextPage={props.data.paymentOrchestrationNextPage}
      />
      <SolutionsItem
        cols={props.data.universalPaymentAccountContent}
        cover={props.data.universalPaymentAccountCover}
        nextPage={props.data.universalPaymentAccountNextPage}
      />
      <SolutionsItem
        cols={props.data.endUserAppsContent}
        cover={props.data.endUserAppsCover}
        nextPage={props.data.endUserAppsNextPage}
      />
    </div>
  );
};
